import { AddonDTO } from '@/dtos'
import { HostingModel, ServerModel } from '@/models'
import { ProductViewModel } from '@/view-models'

export class ToggleAddonView {
  private model: HostingModel | ServerModel
  private productViewModel: ProductViewModel

  constructor(
    widget: HTMLElement,
    model: HostingModel | ServerModel,
    productViewModel: ProductViewModel
  ) {
    this.model = model
    this.productViewModel = productViewModel

    const addonWidgets =
      widget.querySelectorAll<HTMLElement>('.js-product-addon')

    addonWidgets.forEach((addonWidget) => {
      const checkbox =
        addonWidget.querySelector<HTMLInputElement>('[name^=addons]')
      const { id, name } = addonWidget.dataset as { name?: string; id?: string }

      if (!checkbox) {
        throw new Error('ToggleAddonView: missing checkbox')
      }

      if (!id) {
        throw new Error('ToggleAddonView: addon id undefined')
      }

      if (!name) {
        throw new Error('ToggleAddonView: addon name undefined')
      }

      addonWidget.addEventListener('click', (event) => {
        event.preventDefault()
        const isCheckboxChecked = checkbox.checked
        this.handleSubmit(isCheckboxChecked, id, name)
      })

      checkbox.addEventListener('click', (event) => {
        event.preventDefault()
        const isCheckboxChecked = checkbox.checked
        this.handleSubmit(!isCheckboxChecked, id, name)
        event.stopPropagation()
      })
    })
  }

  handleSubmit(removeAddon: boolean, id: string, name: string): void {
    if (removeAddon) {
      this.model.removeAddon(id)
    } else {
      const addon = new AddonDTO(id, name)
      this.model.addAddon(addon)
    }
    void this.productViewModel.addToCart(this.model)
  }
}
